// extracted by mini-css-extract-plugin
module.exports = {"root":"ChapterControlsInactiveSlider__root","sliderBackground":"ChapterControlsInactiveSlider__sliderBackground colors__compactSliderBackground--background-color","sliderForeground":"ChapterControlsInactiveSlider__sliderForeground colors__compactSliderForeground--background-color"};
    if(module.hot) {
      // 1790535735223
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  